import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {Comment} from '../../core/api/resources/comment.resource';

@Component({
  selector: 'unr-comment-list',
  templateUrl: './comment-list.component.html',
  styleUrls: ['./comment-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnrCommentListComponent {
  @Input() comments: Array<Comment>;
  @Output() selectImage: EventEmitter<string> = new EventEmitter<string>();

  getImages(comment: Comment): string[] {
    const imageUrls: string[] = [...comment.images];
    return imageUrls.splice(1, 2);
  }
}
